<template>
  <div>
    <div class="primarybar hvh-flex">
      <div class="tab" :class="{ active: isActiveUrl(tab) }" v-for="(tab, ind) in tabs" :key="ind">
        <router-link :to="tab.url">
            <span>{{ tab.text }}</span>

<span v-if="tab.url.name === 'itmNotification' && $store.state.itm.notificationCount>0"
            class="custom-badge">
           {{$store.state.itm.notificationCount}}
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios';
import { errorDebug, } from '../../libraries/common';
export default {
  props: ['tabs',],
  data() {
    return {
    };
  },
  methods: {
    isActiveUrl(tab) {
      return tab.url.name === this.$route.name;
    },
    getUnReadNotificationsCount(){
      axios.get(`/ITM/Notification/GetUnReadNotificationsCount`).then(({data} ) =>{
        this.$store.state.itm.notificationCount=data;
      })
        .catch(errorDebug)
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMHorizontalMenu'] = this;
    this.getUnReadNotificationsCount();
  },
}
</script>


<style lang="scss" scoped>
.primarybar {
  background-color: var(--bg-color-1);
  color: white;

  .tab {
    opacity: 0.7;
    a {
      display: block;
      color: white;
      white-space: nowrap;
      padding: 10px 12px;
      border-left: 2px solid var(--bg-color);
      font-weight: 600;
    }
    &.active {
      opacity: 1;
      background: var(--bg-color);
    }
  }
}
.custom-badge {
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 0.2em 0.5em;
  font-size: 0.8em;
  position: relative;
  top: -5px!important;
  right: -3px !important;
}
</style>